export const Capabilities = [
  'attachment-sections',
  'attachment-thumbnail',
  'board-buttons',
  'board-views',
  'card-back-section',
  'card-badges',
  'card-buttons',
  'card-detail-badges',
  'card-from-url',
  'format-url',
  'list-actions',
  'list-sorters',
  'on-enable',
  'on-disable',
  'remove-data',
  'show-settings',
  'authorization-status',
  'show-authorization',
  'save-attachment',
];
